module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Light.1e80ea73.ttf";